import { render, staticRenderFns } from "./DeliveryEditStatus_Details.vue?vue&type=template&id=ea1d1356&"
import script from "./DeliveryEditStatus_Details.vue?vue&type=script&lang=js&"
export * from "./DeliveryEditStatus_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports